import { useState } from 'react'
import { login, setToken } from '../api/client'

export default function Login({ onLoggedIn }: { onLoggedIn: (token: string) => void }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit() {
    if (busy) return
    setBusy(true)
    try {
      const token = await login(email.trim(), password)
      setToken(token)
      onLoggedIn(token)
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Erreur réseau.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <div className="loginbox">
        <div className="logo" style={{ fontSize: 28 }}>
          Klary<b>go</b>
        </div>
        <div className="lsub">connexion</div>
        <input
          type="email"
          placeholder="Email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Mot de passe"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && void submit()}
        />
        {err && <div className="lerr">{err}</div>}
        <button className="lbtn" onClick={() => void submit()}>
          Se connecter
        </button>
      </div>
    </div>
  )
}
